import { useState, useCallback } from 'react';

/**
 * useUIState Hook
 *
 * Manages transient UI states like copy feedback, modal visibility, and animations.
 * Consolidates temporary UI states that don't need to persist.
 */
export const useUIState = () => {
  const [copied, setCopied] = useState(false);
  const [showFigmaModal, setShowFigmaModal] = useState(false);
  const [summaryPulse, setSummaryPulse] = useState(false);

  // Trigger the summary pulse animation
  const triggerPulse = useCallback(() => {
    setSummaryPulse(true);
    const timeout = setTimeout(() => setSummaryPulse(false), 300);
    return () => clearTimeout(timeout);
  }, []);

  // Show copy feedback and Figma modal
  const showCopyFeedback = useCallback((duration = 2000) => {
    setCopied(true);
    setShowFigmaModal(true);
    setTimeout(() => setCopied(false), duration);
  }, []);

  // Hide copy feedback
  const hideCopyFeedback = useCallback(() => {
    setCopied(false);
    setShowFigmaModal(false);
  }, []);

  return {
    copied,
    setCopied,
    showFigmaModal,
    setShowFigmaModal,
    summaryPulse,
    setSummaryPulse,
    triggerPulse,
    showCopyFeedback,
    hideCopyFeedback
  };
};
